import type { SurveyReport } from "@/lib/surveys/report";
import type { ResponseRow, SurveyRecord } from "@/lib/surveys/types";
import { SurveyReportView } from "@/components/surveys/survey-report-view";
import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { load } from "../api/load";
import { seg } from "../api/respond";

type Data = {
  survey: Pick<SurveyRecord, "id" | "title" | "status">;
  report: SurveyReport;
  participants: { rows: ResponseRow[]; total: number; page: number; pageSize: number };
};

export function loader({ params }: LoaderFunctionArgs) {
  return load<Data>(`/api/v1/admin/surveys/${seg(params.id!)}/report?page=1`);
}

export default function SurveyReportPage() {
  const { survey, report, participants } = useLoaderData() as Data;

  return (
    <SurveyReportView
      surveyId={survey.id}
      title={survey.title}
      status={survey.status}
      report={report}
      participants={participants}
    />
  );
}
